module.exports = __webpack_public_path__ + "img/50.1.be78d4cd.jpg";